const getConfig = require("./instance-config");
const allThemes = require("./allThemes");

module.exports = allThemes[getConfig().activeTheme];
